<div class="logo">
  <i class="fa fa-wrench"></i> Administración
</div>

<button mat-button [routerLink]="'company'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-cog"></i><span class="label">Configuración General</span>
</button>

<button mat-button [routerLink]="'locations'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-home"></i><span class="label">{{heading}}</span>
</button>

<!-- Booking  -->
<button mat-button [routerLink]="'booking'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-book"></i><span class="label">Agendamiento</span>
</button>

<!-- Invoicing Info  -->
<button mat-button [routerLink]="'invoicing-info'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-file-invoice-dollar"></i><span class="label">Datos de Facturación</span>
</button>
   
<!-- Objects and Vehicles -->
@if (roleService.can('read','admin') | async) {
  @if (company.object==='Custom') {
    <button mat-button [routerLink]="'objects'" routerLinkActive="active" (click)="onSelect()">
      <i class="fa fa-cubes"></i><span class="label">{{company.object_name || 'Objeto'}}s</span>
    </button>
  }
  @else if (company.object==='Vehicle') {
    <button mat-button [routerLink]="'vehicles'" routerLinkActive="active" (click)="onSelect()">
      <i class="fa fa-car"></i><span class="label">Vehículos</span>
    </button>
  }
}
   
<!-- Roles -->
@if (roleService.can('read','admin') | async) {  
  @if (roleService.can('read','admin') | async) {
    <button mat-button [routerLink]="'roles'" routerLinkActive="active" (click)="onSelect()">
      <i class="fa fa-user-plus"></i><span class="label">Roles</span>
    </button>
  }
}

<!-- Users -->
<button mat-button [routerLink]="'users'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-users"></i><span class="label">Usuarios</span>
</button>
   
<!-- Orders -->
@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'orders'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-book"></i><span class="label">Ordenes de Trabajo</span>
  </button>

  <button mat-button [routerLink]="'works'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-wrench"></i><span class="label">Trabajos</span>
  </button>

<!-- Check Lists -->
  <button mat-button [routerLink]="'check-lists'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-check-square"></i><span class="label">Listas de Trabajo</span>
  </button>
}
   
<!-- Financial Section -->
@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'budgets'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-file-invoice-dollar"></i><span class="label">Presupuestos</span>
  </button>
  <button mat-button [routerLink]="'shares'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-dollar-sign"></i><span class="label">Comisiones</span>
  </button>
}

<!-- Communication Section -->
<button mat-button [routerLink]="'crms/booking'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-user-shield"></i>

    <span class="label">Gestión de Clientes</span>
</button>


<button mat-button [routerLink]="'whatsapp'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-phone"></i>
  <span class="label">Whatsapp</span>
</button>

<!-- Admin Tools -->
@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'apikeys'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-key"></i><span class="label">API Keys</span>
  </button>
}

@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'payments'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-dollar-sign"></i><span class="label">Pagos</span>
  </button>
}

@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'workpoint'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-wrench"></i><span class="label">Punto de Trabajo</span>
  </button>
}

<button mat-button [routerLink]="'patpass'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-wallet"></i><span class="label">Pago Automático</span>
</button>


<!-- Inventory Section -->

<button mat-button [routerLink]="'providers'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-shopping-bag"></i><span class="label">{{ 'provider' | human : null: null: 'plural' }}</span>
</button>

<button mat-button [routerLink]="'products'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-box"></i><span class="label">{{ 'product' | human : null: null: 'plural' }}</span>
</button>

<button mat-button [routerLink]="'kits'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-toolbox"></i><span class="label">Kits</span>
</button>

<button mat-button [routerLink]="'discounts'" routerLinkActive="active" (click)="onSelect()">
  <i class="fa fa-dollar-sign"></i><span class="label">Descuentos</span>
</button>

@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'inventory'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-cart-plus"></i><span class="label">{{'inventory' | human}}</span>
  </button>
}

@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'invoices'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-file-invoice-dollar"></i><span class="label">{{ 'invoice' | human : null: null: 'plural' }}</span>
  </button>
}

<div class="expander"></div>

<!-- Settings Section -->
@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'translate'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-language"></i><span class="label">Traducciones</span>
  </button>
}
@if (roleService.can('read','admin') | async) {
  <button mat-button [routerLink]="'wizard'" routerLinkActive="active" (click)="onSelect()">
    <i class="fa fa-magic"></i><span class="label">Wizard</span>
  </button>
}

<button mat-button [routerLink]="['/main/booking']">
  <i class="fa fa-sign-out-alt"></i><span class="label">Salir a ControlCar</span>
</button>
